export enum VehicleCondition {
  Excellent = 'Excellent',
  Good = 'Good',
  Average = 'Average',
  BelowAverage = 'Below average',
  Poor = 'Poor',
}

export enum ServiceHistory {
  Yes = 'Yes',
  No = 'No',
  NotSure = 'NotSure',
}

export interface PartexValuation {
  colour: string
  derivative: string
  grade: number
  id: string
  model: string
  make: string
  mileage: number
  valueInPence: number
  outstandingFinanceInPence?: number
  serviceHistory: ServiceHistory
  vehicleCondition: VehicleCondition
  emailAddress?: string
  vrm: string
  variantId: string
  expiresAt: number
  meta: Record<string, string>
  createdAt: number
  vin: string
  usedBy?: string
  correlationId: string
  userId?: string
  vehicleDescription: string
}

export interface PartexVehicleVariant {
  id: string
  description: string
  make: string
  vin?: string
  fuelType?: string
}
